export const loginUser = async (username, password, bookId) => {
    try {
        const response = await fetch('https://latangelarogers.com/wp-json/jwt-auth/v1/token', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ username, password })
        });

        const data = await response.json();
        console.log("API Response:", data); // Log full response

        if (!response.ok) {
            throw new Error(data.message || "Invalid credentials. Please check your username and password.");
        }

        if (data.token) {
            localStorage.setItem('token', data.token);
            bookId ? window.location.href = `book-detail?id=${bookId}` : window.location.href = "/";
        }

        return { success: true, token: data.token, data };
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const getTempToken = async () => {
    try {
        const response = await fetch("https://latangelarogers.com/wp-json/jwt-auth/v1/token", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                username: process.env.REACT_APP_WP_ADMIN_USER,
                password: process.env.REACT_APP_WP_ADMIN_PASS,
            }),
        });

        const data = await response.json();

        if (!response.ok || !data.token) {
            throw new Error(data.message || "Failed to fetch temp token");
        }
        return data.token; // ✅ return token (do not store in localStorage)
    } catch (error) {
        console.error("Error fetching temp token:", error);
        return null;
    }
};

export const logoutUser = async () => {
    try {
        const token = localStorage.getItem('token');

        if (!token) {
            console.warn("No token found. User might already be logged out.");
            return { success: true };
        }

        const response = await fetch('https://latangelarogers.com/wp-json/custom-auth/v1/logout', {
            method: 'POST',
            headers: { 'Authorization': `Bearer ${token}` }
        });

        if (!response.ok) {
            const errorData = await response.json();
            return { success: false, error: errorData.message || "Logout failed." };
        }

        return { success: true };
    } catch (error) {
        return { success: false, error: error.message };
    } finally {
        localStorage.removeItem('token');
        window.location.href = '/';
    }
};

export const checkLoginStatus = async () => {
    const token = localStorage.getItem('token');
    if (!token) return false;

    const response = await fetch('https://latangelarogers.com/wp-json/wp/v2/users/me', {
        headers: { 'Authorization': `Bearer ${token}` }
    });

    return response.ok;
};


export const getUserData = async () => {
    const token = localStorage.getItem('token');
    if (!token) return null;

    try {
        const response = await fetch('https://latangelarogers.com/wp-json/wp/v2/users/me?context=edit', {
            method: 'GET',
            headers: { 'Authorization': `Bearer ${token}` },
        });

        if (!response.ok) throw new Error("Failed to fetch user data");

        return await response.json();
    } catch (error) {
        console.error("Error fetching user data:", error);
        return null;
    }
};

export const updateUserData = async (updatedData) => {
    const token = localStorage.getItem('token');
    if (!token) return { success: false, message: "User not authenticated" };

    try {
        const response = await fetch('https://latangelarogers.com/wp-json/wp/v2/users/me', {
            method: 'POST', // WordPress requires POST for user updates
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(updatedData),
        });

        const data = await response.json();

        if (!response.ok) throw new Error(data.message || "Failed to update user data");

        return { success: true, data };
    } catch (error) {
        console.error("Error updating user data:", error);
        return { success: false, message: error.message };
    }
};


export const getAllUsers_ = async () => {
    const token = localStorage.getItem('token');
    if (!token) return null;

    try {
        const response = await fetch('https://latangelarogers.com/wp-json/wp/v2/users?context=edit&per_page=100', {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        if (!response.ok) throw new Error('Failed to fetch all users');
        return await response.json(); // returns an array of users
    } catch (error) {
        console.error('Error fetching all users:', error);
        return null;
    }
};

export const getAllUsers = async () => {
    try {
        const token = await getTempToken();
        if (!token) throw new Error("No temp token available");

        const response = await fetch("https://latangelarogers.com/wp-json/wp/v2/users?context=edit&per_page=100", {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        if (!response.ok) throw new Error("Failed to fetch all users");

        return await response.json(); // returns array of users
    } catch (error) {
        console.error("Error fetching all users:", error);
        return null;
    }
};
















export const registerUser = async ({ email, username, password }) => {
    try {
        const response = await fetch('https://latangelarogers.com/wp-json/custom-auth/v1/register', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email, username, password }),
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || "Registration failed.");
        }

        return { success: true, token: data.token, data };
    } catch (error) {
        return { success: false, message: error.message };
    }
};

export const checkUsernameAvailability = async (username) => {
    try {
        const response = await fetch(`https://latangelarogers.com/wp-json/custom/v1/check-username?username=${username}`);
        const data = await response.json();
        return data.available; // True if available, False if taken
    } catch (error) {
        console.error("Username check error:", error);
        return false;
    }
};

export const checkEmailAvailability = async (email) => {
    try {
        const response = await fetch(`https://latangelarogers.com/wp-json/custom/v1/check-email?email=${email}`);
        const data = await response.json();
        alert(JSON.stringify(data))
        return data.available; // True if available, False if taken
    } catch (error) {
        console.error("Email check error:", error);
        return false;
    }
};


export const fetchVerificationStatus = async () => {
    const token = localStorage.getItem('token');
    if (!token) return { error: new Error("No token found"), response: null };

    try {
        const response = await fetch('https://latangelarogers.com/wp-json/wp/v2/users/me', {
            headers: { 'Authorization': `Bearer ${token}` }
        });

        const data = await response.json();

        if (!response.ok) return { error: new Error(data.message || "Failed to fetch verification status"), response: null };

        return { response: data.is_verified, error: null };
    } catch (error) {
        return { error, response: null };
    }
};


















































export const updateUserNickname = async (nickname) => {
    const token = localStorage.getItem('token');
    if (!token) return { success: false, message: "User not authenticated" };

    try {
        const response = await fetch('https://latangelarogers.com/wp-json/wp/v2/users/me', {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ nickname }), // Try updating normally
        });

        const data = await response.json();

        if (!response.ok) throw new Error(data.message || "Failed to update nickname");

        return { success: true, data };
    } catch (error) {
        console.error("Error updating nickname:", error);
        return { success: false, message: error.message };
    }
};



// Methoth 2 PHP
// 1 .Add this code to your WordPress theme’s functions.php
// function update_user_nickname( $request ) {
//     $user_id = get_current_user_id();
//     if ( !$user_id ) return new WP_Error( 'no_user', 'User not found', array( 'status' => 404 ) );

//     $nickname = sanitize_text_field( $request['nickname'] );
//     update_user_meta( $user_id, 'nickname', $nickname );

//     return rest_ensure_response( array( 'success' => true, 'nickname' => $nickname ) );
// }

// add_action('rest_api_init', function() {
//     register_rest_route('custom-auth/v1', '/update-nickname', array(
//         'methods' => 'POST',
//         'callback' => 'update_user_nickname',
//         'permission_callback' => function() { return is_user_logged_in(); }
//     ));
// });
// 2 .Then, update your nickname from your React app:
// export const updateUserNickname = async (nickname) => {
//     const token = localStorage.getItem('token');
//     if (!token) return { success: false, message: "User not authenticated" };

//     try {
//         const response = await fetch('https://latangelarogers.com/wp-json/custom-auth/v1/update-nickname', {
//             method: 'POST',
//             headers: {
//                 'Authorization': `Bearer ${token}`,
//                 'Content-Type': 'application/json',
//             },
//             body: JSON.stringify({ nickname }),
//         });

//         const data = await response.json();

//         if (!response.ok) throw new Error(data.message || "Failed to update nickname");

//         return { success: true, data };
//     } catch (error) {
//         console.error("Error updating nickname:", error);
//         return { success: false, message: error.message };
//     }
// };
